/**
 * Polyfill to support matches on IE9+
 *
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill}
 */

if (!Element.prototype.matches)
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
